ko.bindingHandlers.enterKey = {
    init: function (element: HTMLElement, valueAccessor, allBindings, viewModel, bindingContext)
    {
    
        const eventHandler = (evt) =>
        {
            if (evt.key === 'Enter')
                ko.unwrap(valueAccessor()).call(null, viewModel, evt);

        }

        element.addEventListener('keydown', eventHandler)

        ko.utils.domNodeDisposal.addDisposeCallback(element, () =>
        {
            element.removeEventListener('keydown', eventHandler)
        });

    }
};
